@use 'styles/colors' as *;
@use 'styles/functions/rem' as *;
@use 'styles/mixins/fonts' as *;

.tab {
    @include largeSemiboldFont;

    color: $tabInactiveColor;
    cursor: pointer;
    display: flex;
    padding: rem(10px);
    text-align: center;
}

.tabActive {
    @include largeBoldFont;

    color: $tabActiveColor;
}
